/**
 * Records the Vite source-module ids (e.g. "src/pages/Home.tsx") that a
 * route's preload step resolved. The SSR prerender pass drains this after
 * preloading a route and maps the ids through the client build manifest to
 * emit exact <link rel="modulepreload"> tags for that page — the same chunk
 * set the browser would otherwise discover serially after the entry parses.
 * A no-op cost on the client (a Set of short strings).
 */
const loaded = new Set<string>();

export function registerLoadedModule(id: string) {
  loaded.add(id);
}

/** Returns and clears the ids registered since the last drain. */
export function drainLoadedModules(): string[] {
  const ids = [...loaded];
  loaded.clear();
  return ids;
}
